
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { User, Settings, LogOut } from 'lucide-react';
import { NavItem } from './types';

interface MobileMenuProps {
  isOpen: boolean;
  navLinks: NavItem[];
  onClose: () => void;
  onLogout: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ 
  isOpen, 
  navLinks,
  onClose,
  onLogout
}) => {
  if (!isOpen) return null;
  
  return (
    <div className="md:hidden p-4 pt-0 bg-black/80 backdrop-blur-lg border-t border-white/10 animate-fade-in max-h-[80vh] overflow-y-auto">
      <nav className="grid grid-cols-2 gap-2">
        {/* Display a prominent logout button at the top for visibility */}
        <Button 
          variant="glass" 
          className="w-full justify-start gap-2 text-neon-pink border-neon-pink/20 hover:border-neon-pink/40 col-span-2 mb-4 animate-slide-up"
          onClick={onLogout}
        >
          <LogOut className="h-4 w-4" />
          <span>Logout</span>
        </Button>
        
        {navLinks.map((link, index) => (
          <Link 
            key={link.path} 
            to={link.path} 
            onClick={onClose}
            style={{ animationDelay: `${index * 30}ms` }}
            className="animate-slide-up"
          >
            <Button
              variant="glass"
              className="w-full justify-start gap-2 hover:text-neon-purple hover:border-neon-purple/30 transition-all duration-300"
            >
              {link.icon}
              <span>{link.label}</span>
            </Button>
          </Link>
        ))}
        <Link to="/profile" onClick={onClose} className="animate-slide-up" style={{ animationDelay: `${navLinks.length * 30}ms` }}>
          <Button variant="glass" className="w-full justify-start gap-2 hover:text-neon-blue hover:border-neon-blue/30 transition-all duration-300">
            <User className="h-4 w-4" />
            <span>Profile</span>
          </Button>
        </Link>
        <Link to="/settings" onClick={onClose} className="animate-slide-up" style={{ animationDelay: `${(navLinks.length + 1) * 30}ms` }}>
          <Button variant="glass" className="w-full justify-start gap-2 hover:text-neon-purple hover:border-neon-purple/30 transition-all duration-300">
            <Settings className="h-4 w-4" />
            <span>Settings</span>
          </Button>
        </Link>
      </nav>
    </div>
  );
};

export default MobileMenu;
